/*! Variant Image Filter – filtra galería y miniaturas por color */
(function() {
  'use strict';

  const COLOR_OPTION_NAME = 'Color'; // usa el nombre exacto de tu opción
  const HIDE_CLASS = 'variant-filter-hidden';

  const GALLERY_SELECTORS = [
    '.product__media-list',
    '[data-media-gallery]',
    '.product-gallery',
    '.product-media-gallery',
    '.product__media-wrapper'
  ];

  const THUMB_ROOT_SELECTORS = [
    '.product__thumbnails-list',
    '.product__thumbnails'
  ];

  // añade CSS para ocultar
  if (!document.querySelector('style[data-variant-filter]')) {
    const s = document.createElement('style');
    s.dataset.variantFilter = 'true';
    s.textContent = `.${HIDE_CLASS}{display:none!important}`;
    document.head.appendChild(s);
  }

  const qs  = (sel, root=document) => root.querySelector(sel);
  const qsa = (sel, root=document) => [...root.querySelectorAll(sel)];

  function getGalleryRoot() {
    return GALLERY_SELECTORS.map(s=>qs(s)).find(Boolean) || null;
  }

  function getThumbsRoot() {
    return THUMB_ROOT_SELECTORS.map(s=>qs(s)).find(Boolean) || null;
  }

  function itemNodes(root){
    if (!root) return [];
    const items = qsa('[data-media-id], .product__media-item, figure, li', root);
    return items.length ? items : qsa('img', root).map(i => i.closest('figure,div,li') || i);
  }

  const getAlt = n =>
    (n.querySelector('img')?.alt || n.dataset.alt || '').trim();

  function getSelectedColor() {
    let r = qs(`input[name="options[${COLOR_OPTION_NAME}]"]:checked`);
    if (r?.value) return r.value.trim();
    let s = qs(`select[name="options[${COLOR_OPTION_NAME}]"]`);
    if (s?.value) return s.value.trim();

    // swatches
    let btn = qs(`[data-option-name="${COLOR_OPTION_NAME}"] [aria-pressed="true"]`)
           || qs(`[data-option-name="${COLOR_OPTION_NAME}"] [aria-checked="true"]`);
    if (btn) return (btn.dataset.optionValue || btn.ariaLabel || btn.textContent || '').trim();

    let sel = qs(`.swatch[data-option-name="${COLOR_OPTION_NAME}"] .is-selected`)
           || qs(`[data-option-name="${COLOR_OPTION_NAME}"] .is-selected`);
    if (sel) return (sel.dataset.optionValue || sel.ariaLabel || sel.textContent || '').trim();

    r = qs(`input[name*="Color"]:checked`);
    if (r?.value) return r.value.trim();
    s = qs(`select[name*="Color"]`);
    if (s?.value) return s.value.trim();
    return null;
  }

  function filterThumbnails(color) {
    const tRoot = getThumbsRoot();
    if (!tRoot) return;
    qsa('.product__thumbnail,[data-media-id]', tRoot)
      .forEach(el => el.classList.toggle(HIDE_CLASS, !getAlt(el).toLowerCase().includes(color.toLowerCase())));
  }

  function applyFilter(){
    const color = getSelectedColor();
    const root  = getGalleryRoot();
    if (!color || !root) return;

    itemNodes(root).forEach(node =>
      node.classList.toggle(HIDE_CLASS, !getAlt(node).toLowerCase().includes(color.toLowerCase()))
    );
    filterThumbnails(color);
  }

  // eventos
  document.addEventListener('change', e => {
    const t = e.target;
    if (!t) return;
    if (
      t.matches(`input[name="options[${COLOR_OPTION_NAME}]"]`) ||
      t.matches(`select[name="options[${COLOR_OPTION_NAME}]"]`) ||
      t.name?.includes('Color') ||
      t.matches('input[name="id"]') || t.matches('select[name="id"]')
    ) setTimeout(applyFilter, 0);
  });

  document.addEventListener('click', e => {
    if (e.target.closest(`[data-option-name="${COLOR_OPTION_NAME}"]`))
      setTimeout(applyFilter, 0);
  });

  document.addEventListener('variant:change', () => setTimeout(applyFilter, 0));
  new MutationObserver(() => setTimeout(applyFilter, 0))
    .observe(document.documentElement, {childList:true,subtree:true});

  window.addEventListener('load', applyFilter);
  document.addEventListener('DOMContentLoaded', applyFilter);
})();
/* === Sync de navegación en galería filtrada — SOLO ESCRITORIO === */
(function () {
  'use strict';
  var HIDE = 'variant-filter-hidden';
  var isDesktop = function () { return window.matchMedia('(min-width:1024px)').matches; };

  function galleryOf(el) {
    return el.closest('media-gallery, .product__gallery') ||
           document.querySelector('media-gallery, .product__gallery');
  }
  function sliderOf(g) { return g && g.querySelector('slider-element, [id^="SliderGallery"]'); }

  function visibleSlides(sl) {
    return Array.prototype.filter.call(
      sl.querySelectorAll('.product__media'),
      function (s) { return !s.classList.contains(HIDE) && s.offsetParent !== null; }
    );
  }
  function scroller(sl) {
    var list = sl.querySelector('.product__media-list');
    if (sl.scrollWidth > sl.clientWidth + 2) return sl;
    if (list && list.scrollWidth > list.clientWidth + 2) return list;
    return sl;
  }
  function setArrows(g, len, idx) {
    var p = g.querySelector('[is="previous-button"]'), n = g.querySelector('[is="next-button"]');
    if (p) p.disabled = idx <= 0;
    if (n) n.disabled = idx >= len - 1;
  }
  function syncDots(g, id) {
    var dots = g.querySelector('media-dots, .product__thumbnails-list');
    if (!dots) return;
    dots.querySelectorAll('.product__thumbnail').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-media-id') === id ? 'true' : 'false');
    });
  }
  function goTo(g, slide) {
    if (!slide) return;
    var sl = sliderOf(g); if (!sl) return;
    var sc = scroller(sl);
    var d = slide.getBoundingClientRect().left - sc.getBoundingClientRect().left;
    sc.scrollTo({ left: sc.scrollLeft + d, behavior: 'smooth' });
    var list = visibleSlides(sl);
    syncDots(g, slide.getAttribute('data-media-id'));
    setArrows(g, list.length, list.indexOf(slide));
  }
  function currentIndex(sl, list) {
    var box = sl.getBoundingClientRect(), center = box.left + box.width / 2, best = 0, bd = Infinity;
    list.forEach(function (s, i) {
      var r = s.getBoundingClientRect(), dd = Math.abs(r.left + r.width / 2 - center);
      if (dd < bd) { bd = dd; best = i; }
    });
    return best;
  }

  // Intercepta clic en flechas / miniaturas antes que el tema
  document.addEventListener('click', function (e) {
    if (!isDesktop()) return;
    var arrow = e.target.closest('[is="previous-button"],[is="next-button"]');
    var thumb = e.target.closest('.product__thumbnail');
    if (!arrow && !thumb) return;

    var g = galleryOf(e.target); if (!g) return;
    var sl = sliderOf(g); if (!sl) return;
    var list = visibleSlides(sl); if (!list.length) return;

    e.preventDefault();
    e.stopImmediatePropagation(); // anula el handler roto del tema

    if (thumb) {
      var id = thumb.getAttribute('data-media-id');
      goTo(g, sl.querySelector('.product__media[data-media-id="' + id + '"]'));
    } else {
      var dir = arrow.getAttribute('is') === 'next-button' ? 1 : -1;
      var i = currentIndex(sl, list);
      goTo(g, list[Math.min(list.length - 1, Math.max(0, i + dir))]);
    }
  }, true);

  // Al cambiar de color, deja el visor en la primera imagen visible
  document.addEventListener('variant:change', function () {
    if (!isDesktop()) return;
    setTimeout(function () {
      var g = document.querySelector('media-gallery, .product__gallery'); if (!g) return;
      var sl = sliderOf(g); if (!sl) return;
      goTo(g, visibleSlides(sl)[0]);
    }, 80);
  });
})();